import { render, staticRenderFns } from "./DataSubmissionOilMaker.vue?vue&type=template&id=263189fa&scoped=true"
import script from "./DataSubmissionOilMaker.vue?vue&type=script&lang=js"
export * from "./DataSubmissionOilMaker.vue?vue&type=script&lang=js"
import style0 from "./ds-common.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./DataSubmissionOilMaker.vue?vue&type=style&index=1&id=263189fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263189fa",
  null
  
)

export default component.exports